import React from 'react'
import { Button, Modal, ModalBody } from 'reactstrap';
import "./ModalAutorizacion.css";
import { validarPasswordEliminar } from '../../../../Services/Validaciones';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { estiloColorError, estilosModal, estiloFiltroEncabezados } from '../../../../Services/PaletaDeColores';
import {
  deleteProductoIngredienteActivo, deleteProductoPlagaControlar, deleteProductoCultivoAutorizado,
  deleteProductoPresentaciones, deleteProductoDocumento
} from '../../../../Services/Api';


export default class ModalAutorizacion extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: props.show,
      titulo: props.titulomodal,
      accion:props.accion,

      colormsgerror: estiloColorError().msgerror,
      estilosmodal: estilosModal(),
      colortitulo: estiloFiltroEncabezados().colortitulos,

      txtpassword: "",
      vermsgerrortxtpassword: false,
      msgerrortxtpassword: "",

      txtprincipal: "",
      vermsgerrortxtprincipal: false,
      msgerrortxtprincipal: ""

    }

  }
  async componentDidMount() {
    setTimeout(async () => {
      this.refInput.focus();
    }, 500);
  }

  setLoadingSpinner = (bandera) => {
    this.props.setloadingspinner(bandera);
  }

  showModal = (accion) => {
    this.setState({ show: false });
    setTimeout(() => {
      this.props.cerrarModalAtutorizacion(accion);
    }, 200);
  }

  escribir = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  eliminarItem = async () => {

    let validacionescorrectas = true
    this.setState({ vermsgerrortxtpassword: false })
    this.setState({ vermsgerrortxtprincipal: false })

    let txtpassword = validarPasswordEliminar(this.state.txtpassword.trim())
    if (txtpassword.codigo == "invalid") {
      this.setState({ msgerrortxtpassword: txtpassword.mensaje })
      this.setState({ vermsgerrortxtpassword: true })
      validacionescorrectas = false;
    }

    if (this.props.item.principal) {
      this.setState({ msgerrortxtprincipal: 'Un registro pincipal no puede ser eliminado' })
      this.setState({ vermsgerrortxtprincipal: true })
      validacionescorrectas = false;
    }

    if (validacionescorrectas) {
      this.setLoadingSpinner(true);
      var resp = {};
      var json = {};

      if (this.props.accion == 0) {
        json = {
          idcatalogoproducto_ingredienteactivo: this.props.item.idcatalogoproducto_ingredienteactivo,
          password: this.state.txtpassword
        }
        resp = await deleteProductoIngredienteActivo(json)
      }
      else if (this.props.accion == 1) {
        json = {
          idcatalogoproducto_plaga: this.props.item.idcatalogoproducto_plaga,
          password: this.state.txtpassword
        }
        resp = await deleteProductoPlagaControlar(json)
      }
      else if (this.props.accion == 2) {
        json = {
          idcatalogoproducto_cultivo: this.props.item.idcatalogoproducto_cultivo,
          password: this.state.txtpassword
        }
        resp = await deleteProductoCultivoAutorizado(json)
      }
      else if (this.props.accion == 3) {
        json = {
          idcatalogoproducto_empaque: this.props.item.idcatalogoproducto_empaque,
          password: this.state.txtpassword
        }
        resp = await deleteProductoPresentaciones(json)
      }
      else if (this.props.accion == 4) {
        json = {
          idproductodocumento: this.props.item.idcatalogo_producto_documento,
          password: this.state.txtpassword
        }
        resp = await deleteProductoDocumento(json)
      }

      if(resp.code == 0){
        if (this.state.accion == 0) {
            this.showModal('1')
        }
        else if (this.state.accion == 1) {
            this.showModal('2')
        }
        else if (this.state.accion == 2) {
          this.showModal('3')
        }
        else if (this.state.accion == 3) {
          this.showModal('4')
        }
        else if (this.state.accion == 4) {
          this.showModal('5')
        }
      }
      else if(resp.code == 200){
          this.setLoadingSpinner(false);
          this.setState({ confirmarenvio: !this.state.confirmarenvio })
          toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
          return;
      }
      else if(resp.code == 300){
          this.setLoadingSpinner(false);
          this.setState({ confirmarenvio: !this.state.confirmarenvio })
          toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
          return;
      }
      else if(resp.code == 400){
          this.setLoadingSpinner(false);
          this.setState({ confirmarenvio: !this.state.confirmarenvio })
          toast.error("Operación rechazada, vuelve a intentar", { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
          return;
      }
      else if (resp.code == 1000) {
          this.setLoadingSpinner(false);
          toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT });
          return;
      }else{
          this.setLoadingSpinner(false);
          this.setState({ confirmarenvio: !this.state.confirmarenvio })
          toast.error("Error de conexión", { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
      }
    }
  }


  render() {
    return (

      <>
        <ToastContainer />

        <Modal isOpen={this.state.show}
          size="md"
          aria-labelledby=""
          centered>
          <ModalBody>
            <div className="divTituloModal">
              <label className="modalLblTitulo letraTitulos" style={{ color: this.state.colortitulo }} >{this.state.titulo}</label>
            </div>

            <br />

            <div className="divModalEliminar">
              <div className="divContenedorModal" style={{ backgroundColor: this.state.estilosmodal.fondocontenedormodal, boxSizing: "content-box" }}>

                <p className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>Ingresa tu contraseña</p>

                <input className='lblTextoModal letraNormal' style={{ color: this.state.estilosmodal.colorlbltextomodal, backgroundColor: this.state.estilosmodal.fondocontenedormodal, border: 'none', borderBottom: this.state.estilosmodal.colorborderbottom }}
                  type={'password'} value={this.state.txtpassword} onChange={this.escribir("txtpassword")} ref={(input) => { this.refInput = input; }}></input>

                {this.state.vermsgerrortxtpassword ? <p className="msgError letraNormal"
                  style={{ color: this.state.colormsgerror }}>{this.state.msgerrortxtpassword}</p> : null}

                {(!this.state.vermsgerrortxtpassword && this.state.vermsgerrortxtprincipal) ? <p className="msgError letraNormal"
                  style={{ color: this.state.colormsgerror }}>{this.state.msgerrortxtprincipal}</p> : null}


              </div>
            </div>

            <div className="divBtnContenedorModal" >
              <Button className="btnCancelModal" onClick={() => this.showModal('0')}>Cancelar</Button>
              <Button className="btnAceptarModal" onClick={() => this.eliminarItem()} >Continuar</Button>
            </div>

          </ModalBody>

        </Modal>
      </>
    )
  }
}
